module.exports = "/hwa/_next/static/images/skipBag-627d538f3beffa249a8764f4a3962c56.png";